<template>
  <div id="footer">
    <img
      src="@/assets/logo/gcg_logo.png"
      alt="GCG Logo"
      width="40"
    />

    <el-divider
      class="customDivider"
      direction="vertical"
    />

    <span>
      Powered by
      <a
        href="https://globalcoachgroup.com/"
        target="_blank"
        style="color: white;"
      >
        Global Coach Group
      </a>
      © 2021
    </span>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
#footer {
  height: 40px;
  background: #001c32;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;

  .customDivider {
    margin: 0 16px;
  }
}
</style>
